// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3C-sf","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1zKVx","obliqueLine":"membershipbadge_obliqueLine__50N2D"};